import SummaryCard from "./summary-card";

export default SummaryCard;